import { Grid } from '@mui/material'
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro'

const SimpleTable = ({ columns, rows, pagination = true, ...rest }: DataGridProProps) => (
  <Grid
    sx={{
      flexDirection: 'column',
    }}
  >
    <DataGridPro
      rows={rows}
      columns={columns}
      disableRowSelectionOnClick={true}
      disableColumnMenu={true}
      disableColumnReorder={true}
      disableVirtualization={true}
      sx={{ border: 0 }}
      getRowHeight={() => 'auto'}
      /* pagination props */
      pagination={pagination}
      hideFooter={(rows || []).length < 5}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 5 },
        },
      }}
      pageSizeOptions={[5, 10, 20, 100]}
      {...rest}
    />
  </Grid>
)

export default SimpleTable
